import {
  Box,
  Divider,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";
import CustomRangePicker from "../DateRangePicker";
import BranchMenu from "../MenuDropDown/BranchMenu";
import TeamMenu from "../MenuDropDown/TeamMenu";
import TypeMenu from "../MenuDropDown/TypeMenu";

const style = {
  muiTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #A6A9AC`,
      },
    },
  },
};

function AppContainer({
  headProps,
  children,
  handleChangetype,
  primaryHeading,
  secondaryHeading,
  searchValue,
  onChange,
  showSerach,
  showFilterBtn,
  handleFilterData,
  showBackButton,
  handleBack,
  childrenProps,
  showCalenderIcon,
  handleFilterByDate,
  showRangerPicker,
  customIcom,
  showBranchesMenu,
  showTeamMenu,
  height,
  branchesByBusiness,
  selectedBusiness,
  selectedBranchId,
  handleChangeBranch,
  teamByBusiness,
  selectedBranche,
  selectedTeamId,
  handleChangeTeam,
  setStartDate,
  startDate,
  setEndDate,
  handleDatesChange,
  endDate,
  showTypeMenu,
  typeData,
  selectedVal,
  showSerachButton,
  handleSearch,
  // New Work Props
  showDateRange,
}) {
  return (
    <Paper sx={{ borderRadius: "6px" }}>
      <Stack
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { sm: "center" },
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"} flex={1}>
          {showBackButton ? (
            <IconButton
              onClick={handleBack}
              disableRipple
              sx={{
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <img
                src={allIcons.backIcon}
                alt={"card-icon"}
                width={25}
                height={25}
              />
            </IconButton>
          ) : customIcom ? (
            customIcom
          ) : (
            <img
              src={allIcons.cardIcon}
              alt={"back-icon"}
              width={30}
              height={30}
            />
          )}
          <Box>
            <Typography
              variant={"body1"}
              fontWeight={600}
              lineHeight={"normal"}
            >
              {primaryHeading}
            </Typography>
            <Typography
              variant={"body2"}
              fontSize={"0.8rem"}
              color={appcolors.crayolaGrey}
            >
              {secondaryHeading}
            </Typography>
          </Box>
        </Stack>
        {headProps && headProps}
      </Stack>
      <Divider />
      <Stack
        gap={1.5}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        p={"8px 16px"}
        bgcolor={appcolors.primaryLight}
      >
        {showSerach && (
          <Box>
            <TextField
              sx={style.muiTextField}
              placeholder="Search Name"
              variant="outlined"
              value={searchValue}
              onChange={onChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ cursor: "pointer" }}>
                    <img
                      src={allIcons.searchIcon}
                      alt="search-icon"
                      width={25}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        )}

        {showFilterBtn && (
          <Box>
            <Box height={40}>
              <GlobalButton
                variant={"contained"}
                btnText={"Filter"}
                startIcon={
                  <img src={allIcons.filterIcon} alt="filter-icon" width={20} />
                }
                styleProps={{
                  fontWeight: 400,
                  fontSize: "0.875rem",
                }}
                handleClickBtn={handleFilterData}
              />
            </Box>
          </Box>
        )}
        {showCalenderIcon && (
          <Box>
            <IconButton
              onClick={handleFilterByDate}
              sx={{
                padding: "2px",
                "&:hover": { backgroundColor: "transparent" },
              }}
            >
              <img
                src={allIcons.calendarGreyIcon}
                alt="calendar-icon"
                width={25}
              />
            </IconButton>
          </Box>
        )}
        <Typography />
        <Stack direction={"row"} alignItems={"center"}>
          {showDateRange && showDateRange}
          {showRangerPicker && (
            <Box>
              <CustomRangePicker
                stackProps={{
                  boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
                  borderRadius: "6px",
                }}
                endDate={endDate}
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                handleDatesChange={handleDatesChange}
              />
            </Box>
          )}
          {showBranchesMenu && (
            <Box>
              <BranchMenu
                data={branchesByBusiness}
                business={selectedBusiness}
                selectedBranch={selectedBranchId}
                onChange={(e, selectedBranchId) =>
                  handleChangeBranch(e, selectedBranchId)
                }
              />
            </Box>
          )}
          {showTeamMenu && (
            <Box>
              <TeamMenu
                data={teamByBusiness}
                branche={selectedBranche}
                selectedTeam={selectedTeamId}
                onChange={(e, selectedTeamId) =>
                  handleChangeTeam(e, selectedTeamId)
                }
              />
            </Box>
          )}
          {showTypeMenu && (
            <Box>
              <TypeMenu
                data={typeData}
                selectedType={selectedVal}
                onChange={(e, selectedVal) => handleChangetype(e, selectedVal)}
              />
            </Box>
          )}
          {showSerachButton && (
            <Box>
              <GlobalButton
                btnText={"Search"}
                handleClickBtn={handleSearch}
                styleProps={{
                  color: appcolors.white,
                  height: 40,
                  width: 150,
                  ml: 2,
                }}
              />
            </Box>
          )}
        </Stack>
      </Stack>
      <Box p={"12px 16px"} height={height ? height : null} {...childrenProps}>
        {children}
      </Box>
    </Paper>
  );
}

export default AppContainer;
